'use client';

import { useEffect, useRef, useState } from 'react';

export const useIsClipped = <T extends HTMLElement>(_dependency: unknown) => {
  const ref = useRef<T>(null);
  const [isClipped, setIsClipped] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (el) setIsClipped(el.scrollWidth > el.clientWidth);
  }, []);

  return [ref, isClipped] as const;
};
